window.HGW_POPUP_TEMPLATE = `
<div id="hgw-overlay" class="hgw-overlay" style="opacity:0">
  <div id="hgw-modal" class="hgw-modal" lang="en">

    <!-- Close button -->
    <button id="hgw-close" class="hgw-close" aria-label="Close">
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M6 6L18 18M18 6L6 18"
              stroke="#222"
              stroke-width="2"
              stroke-linecap="round" />
      </svg>
    </button>

    <!-- Progress -->
    <div class="hgw-progress" aria-hidden="true">
      <span class="hgw-progress-step" data-step="1"></span>
      <span class="hgw-progress-line"></span>
      <span class="hgw-progress-step" data-step="2"></span>
      <span class="hgw-progress-line"></span>
      <span class="hgw-progress-step" data-step="3"></span>
      <span class="hgw-progress-line"></span>
      <span class="hgw-progress-step" data-step="4"></span>
      <span class="hgw-progress-line"></span>
      <span class="hgw-progress-step" data-step="5"></span>
    </div>

    <!-- STEP 1: Method -->
    <div class="hgw-step" data-step="1">
      <div class="hgw-option-group">

        <div>
          <input
            class="hgw-card-input"
            type="radio"
            id="hgw-method-delivery"
            name="hgw_method"
            value="delivery"
          />
          <label class="hgw-card" for="hgw-method-delivery">
            <span class="hgw-card-check" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M5 13l4 4L19 7"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
              </svg>
            </span>
            <span class="hgw-card-icon" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M4 7h10v10H4z" stroke="currentColor" stroke-width="1.6" />
                <path d="M14 10h3l3 3v4h-6"
                      stroke="currentColor"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                <path d="M7 17a1.5 1.5 0 1 0 0.001 0z
                         M17 17a1.5 1.5 0 1 0 0.001 0z"
                      fill="currentColor" />
              </svg>
            </span>
            <span>
              <div class="hgw-card-title">Delivery</div>
              <div class="hgw-card-subtitle">Ship to your address</div>
            </span>
          </label>
        </div>

        <div>
          <input
            class="hgw-card-input"
            type="radio"
            id="hgw-method-pickup"
            name="hgw_method"
            value="pickup"
          />
          <label class="hgw-card" for="hgw-method-pickup">
            <span class="hgw-card-check" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M5 13l4 4L19 7"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
              </svg>
            </span>
            <span class="hgw-card-icon" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M4 20h16M6 20V8l6-4 6 4v12"
                      stroke="currentColor"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                <path d="M9 20v-5h6v5"
                      stroke="currentColor"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
              </svg>
            </span>
            <span>
              <div class="hgw-card-title">Local pickup</div>
              <div class="hgw-card-subtitle">Collect at a store</div>
            </span>
          </label>
        </div>

      </div>

      <div id="hgw-step1-delivery-warning" class="hgw-step-warning" hidden>
        <strong>Delivery is unavailable for this cart.</strong>
        <p id="hgw-step1-delivery-warning-text">
          Some items in your cart are currently available for pickup only. Please choose pickup to continue.
        </p>
      </div>
    </div>

    <!-- STEP 2: Fulfillment details -->
    <div class="hgw-step" data-step="2">

      <!-- Pickup -->
      <div data-method="pickup">
        <label class="hgw-field-label">Choose your pickup store</label>
        <select id="pickup-store" class="hgw-field">
          <option value="">Select store</option>
        </select>
      </div>

      <!-- Delivery -->
      <div data-method="delivery" hidden>
        <label class="hgw-field-label">Delivery address</label>
        <input
          type="text"
          id="delivery-address"
          class="hgw-field"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
        />

        <ul id="hgw-address-suggestions" class="hgw-suggestions"></ul>

        <label class="hgw-field-label">Address details <span class="hgw-optional">(optional)</span></label>
        <input
          type="text"
          id="delivery-address-extra"
          class="hgw-field"
          placeholder="Unit / Apt / Building / Gate code / Delivery notes"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="sentences"
          spellcheck="false"
        />

        <div class="hgw-grid-2">
          <div>
            <label class="hgw-field-label">Suburb</label>
            <input
              type="text"
              id="delivery-suburb"
              class="hgw-field"
              placeholder="e.g. Innaloo"
              autocomplete="address-level2"
            />
          </div>

          <div>
            <label class="hgw-field-label">Postcode</label>
            <input
              type="text"
              id="delivery-postcode"
              class="hgw-field"
              placeholder="e.g. 6018"
              inputmode="numeric"
              autocomplete="postal-code"
            />
          </div>
        </div>
      </div>

    </div>

    <!-- STEP 3 -->
    <div class="hgw-step" data-step="3">

    <!-- Pickup Date -->
    <div data-method="pickup">
      <label class="hgw-field-label">Pick a pickup date</label>
      <input
        type="text"
        id="pickup-date-display"
        class="hgw-field"
        placeholder="Select pickup date"
        readonly
        aria-label="Pickup date"
      />
      <input
        type="date"
        id="pickup-date"
        tabindex="-1"
        aria-hidden="true"
        class="hgw-hidden-input"
      />
      <div
        id="pickup-date-calendar"
        class="hgw-calendar"
        aria-label="Pickup date calendar"
      ></div>

      <div id="hgw-date-warning"
          class="hgw-warning"
          style="display:none;">
      </div>
    </div>

    <!-- ================= DELIVERY ================= -->
    <div data-method="delivery" hidden>

      <div class="hgw-summary-block">
        <div>
          <strong>Delivery Area:</strong>
          <span id="hgw-delivery-area">—</span>
        </div>

        <div>
          <strong>Parcels:</strong>
          <span id="hgw-parcel-count">0</span>
        </div>

        <div>
          <strong>Base Shipping:</strong>
          <span id="hgw-shipping-cost">—</span>
        </div>
      </div>

      <div id="hgw-policy-warning"></div>

      <label class="hgw-option-card">
        <input type="checkbox" id="hgw-policy-agree">
        <span class="hgw-option-text">
          I understand and agree to the delivery policy.
        </span>
      </label>
    </div>

    <div class="hgw-policy-link-row">
      <a
        href="${window.HGW_POLICY_URL || '/pages/shipping-pickup-policy'}"
        class="hgw-policy-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Shipping &amp; Pickup Policy
      </a>
    </div>
    </div>

    <!-- STEP 4 -->
    <div class="hgw-step" data-step="4">

    <!-- Pickup Time -->
    <div data-method="pickup">
      <label class="hgw-field-label">Choose a pickup time</label>

      <select id="pickup-time" class="hgw-field hgw-hidden"></select>

      <input
        type="text"
        id="pickup-time-display"
        class="hgw-field"
        placeholder="Select pickup time"
        readonly
        aria-label="Pickup time"
      />

      <div id="pickup-time-wheel" class="hgw-time-wheel">
        <div class="hgw-time-wheel-inner"></div>
      </div>

      <div id="hgw-time-warning"
          class="hgw-warning"
          style="display:none;">
      </div>
    </div>

    <!-- ================= DELIVERY ================= -->
      <div data-method="delivery" hidden>

        <label class="hgw-field-label">Select dispatch date</label>

        <div id="hgw-calendar-container"></div>

        <div id="hgw-dispatch-info" class="hgw-dispatch-info"></div>
      </div>
    </div>

<!-- ================= STEP 5: SUMMARY ================= -->
<div class="hgw-summary" id="hgw-summary" style="display:none">

  <!-- Header -->
  <div class="hgw-summary-header">
    <div class="hgw-summary-header-left">
      <span class="hgw-summary-header-title">Summary</span>
    </div>

    <button
      type="button"
      class="hgw-summary-home"
      data-summary-home
      aria-label="Back to Step 1"
      title="Back to Step 1"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 10.5 12 3l9 7.5"/>
        <path d="M5 10v10a1 1 0 0 0 1 1h4v-7h4v7h4a1 1 0 0 0 1-1V10"/>
      </svg>
    </button>
  </div>


  <!-- ================= PICKUP ================= -->
  <div class="hgw-summary-group" data-method="pickup" hidden>

    <div class="hgw-summary-section">
      <div class="hgw-summary-section-header">
        <span class="hgw-summary-section-icon">🏬</span>
        <span class="hgw-summary-section-title">Pickup details</span>
        <span class="hgw-summary-chevron">▾</span>
      </div>

      <div class="hgw-summary-item">
        <span class="hgw-summary-label">Pickup store</span>
        <span class="hgw-summary-value hgw-summary-value--right" data-summary="store"></span>
        <button type="button" class="hgw-summary-change" data-change-step="2">✎</button>
      </div>

      <div class="hgw-summary-item">
        <span class="hgw-summary-label">Pickup date</span>
        <span class="hgw-summary-value hgw-summary-value--right" data-summary="date"></span>
        <button type="button" class="hgw-summary-change" data-change-step="3">✎</button>
      </div>

      <div class="hgw-summary-item">
        <span class="hgw-summary-label">Pickup time</span>
        <span class="hgw-summary-value hgw-summary-value--right" data-summary="time"></span>
        <button type="button" class="hgw-summary-change" data-change-step="4">✎</button>
      </div>
    </div>

    <!-- Pickup Note -->
    <div class="hgw-summary-section hgw-note-section">
      <div class="hgw-summary-section-header hgw-note-toggle">
        <span class="hgw-summary-section-icon">✎</span>
        <span class="hgw-summary-section-title">Add delivery note</span>
        <span class="hgw-summary-chevron">▾</span>
      </div>

      <div class="hgw-note-content">
        <textarea
          class="hgw-field hgw-order-note"
          rows="3"
          placeholder="(optional)"
        ></textarea>
      </div>
    </div>
  </div>

  <!-- ================= DELIVERY ================= -->
  <div class="hgw-summary-group" data-method="delivery" hidden>

    <!-- Location -->
    <div class="hgw-summary-section"
     data-summary-section="delivery-location">
      <div class="hgw-summary-section-header">
        <span class="hgw-summary-section-icon">📍</span>
        <span class="hgw-summary-section-title">Delivery location</span>
        <span class="hgw-summary-chevron">▾</span>
      </div>

      <div class="hgw-summary-item hgw-summary-item--stack">
        <div class="hgw-summary-top">
          <span class="hgw-summary-label">Delivery address</span>
          <button type="button" class="hgw-summary-change" data-change-step="2">✎</button>
        </div>
        <div class="hgw-summary-value hgw-summary-value--stack" data-summary="delivery_address"></div>
      </div>

      <div class="hgw-summary-item">
        <span class="hgw-summary-label">Delivery area</span>
        <span class="hgw-summary-value hgw-summary-value--right" data-summary="delivery_area"></span>
        <span class="hgw-summary-action-placeholder"></span>
      </div>
    </div>

    <!-- Dates -->
    <div class="hgw-summary-section">
      <div class="hgw-summary-section-header">
        <span class="hgw-summary-section-icon">📅</span>
        <span class="hgw-summary-section-title">Dispatch & arrival</span>
        <span class="hgw-summary-chevron">▾</span>
      </div>

      <div class="hgw-summary-item">
        <span class="hgw-summary-label">Dispatch date</span>
        <span class="hgw-summary-value hgw-summary-value--right" data-summary="dispatch_date"></span>
        <button type="button" class="hgw-summary-change" data-change-step="4">✎</button>
      </div>

      <div class="hgw-summary-item">
        <span class="hgw-summary-label">Delivery time</span>
        <span class="hgw-summary-value hgw-summary-value--right" data-summary="estimated_delivery"></span>
        <span class="hgw-summary-action-placeholder"></span>
      </div>
    </div>

    <!-- Shipping -->
    <div class="hgw-summary-section">
      <div class="hgw-summary-section-header">
        <span class="hgw-summary-section-icon">🚚</span>
        <span class="hgw-summary-section-title">Shipping & fees</span>
        <span class="hgw-summary-chevron">▾</span>
      </div>

      <div class="hgw-summary-item">
        <span class="hgw-summary-label">Parcels</span>
        <span class="hgw-summary-value hgw-summary-value--right" data-summary="parcel_info"></span>
        <span class="hgw-summary-action-placeholder"></span>
      </div>

      <div class="hgw-summary-item hgw-summary-item--total">
        <span class="hgw-summary-label">Shipping total</span>
        <span class="hgw-summary-value hgw-summary-value--right" data-summary="shipping_total"></span>
        <span class="hgw-summary-action-placeholder"></span>
      </div>
    </div>

    <!-- Delivery Note -->
    <div class="hgw-summary-section hgw-note-section">
      <div class="hgw-summary-section-header hgw-note-toggle">
        <span class="hgw-summary-section-icon">✎</span>
        <span class="hgw-summary-section-title">Add delivery note</span>
        <span class="hgw-summary-chevron">▾</span>
      </div>

      <div class="hgw-note-content">
        <textarea
          class="hgw-field hgw-order-note"
          rows="3"
          placeholder="(optional)"
        ></textarea>
      </div>
    </div>
  </div>
</div>

    <!-- Footer -->
    <div class="hgw-footer">
      <button class="hgw-btn-prev" data-action="prev">Previous</button>

      <button class="hgw-btn-next" data-action="next">
        Next
      </button>

      <button id="hgw-confirm">
        <span class="btn-label-full">Continue to checkout</span>
        <span class="btn-label-short">Continue</span>
      </button>
    </div>

  </div>
</div>
`;
